import { GET_NOTE } from '../actions/action.types';

export default (state = null, action) => {
  switch (action.type) {
    case GET_NOTE:
      return action.payload;
    default:
      return state;
  }
};
